<template>
    <div class="layout layout-center menu-bg">
        <div id="splash">
            <Picture src="res/gfx/ball_title@4x.png"></Picture>
            <div>MADVOLLEY</div>
        </div>
    </div>
</template>

<script>
export default {};
</script>